import { PostData } from "../../posts/post.models";
import { randomNumber } from "../../utils/randomization";
import { InteractionGenerationStrategy } from "../generation.models";

export class InteractionGenerator {
  private strategy: InteractionGenerationStrategy;
  private key: keyof PostData;

  constructor(strategy: InteractionGenerationStrategy, key: keyof PostData) {
    this.strategy = strategy;
    this.key = key;
  }

  addPostInteractions(posts: PostData[]): PostData[] {
    const min = this.strategy.min;
    let max = this.strategy.max;

    console.debug(
      `generating post ${this.key} interactions between ${min} and ${max}`
    );

    return posts.map((post, index) => {
      if (post.contentType == "friend-post" && this.key == "dislikes") {
        /// friend posts have dislikes of 0.
        return {
          ...post,
          [this.key]: 0,
        };
      }

      if (this.strategy.increase_per_post != null) {
        max += this.strategy.increase_per_post * index;
      }

      if (this.strategy.max_cap != null) {
        max = Math.min(this.strategy.max_cap, max);
      }

      let number = randomNumber(min, max);

      return {
        ...post,
        [this.key]: number,
      };
    });
  }
}
